import React, { useEffect, useState } from "react";

import LatestEvents from "../../../../components/Home/AboutLKCTC/LatestEvents";
import { LiveUrl } from "../../../../apiUtils";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

const MediaCoverage = () => {
  const [mediaImg, setMediaImg] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  // const localUrl = "http://localhost:5000";
  // const liveUrl = "https://api-lkctc.simbaquartz.com";
  // export const LiveUrl = "https://api.kclimt.com";

  const fetchMedia = () => {
    axios
      .get(`${LiveUrl}/api/media`)
      .then((response) => setMediaImg(response?.data?.data));
  };
  useEffect(() => {
    fetchMedia();
  }, []);

  useEffect(() => {
    if (!selectedMedia) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setSelectedMedia(null);
      } else if (e.key === "ArrowLeft") {
        setSelectedMedia((prev) => {
          if (!prev) return null;
          const nextIndex = (prev.index - 1 + prev.media.length) % prev.media.length;
          return { ...prev, index: nextIndex };
        });
      } else if (e.key === "ArrowRight") {
        setSelectedMedia((prev) => {
          if (!prev) return null;
          const nextIndex = (prev.index + 1) % prev.media.length;
          return { ...prev, index: nextIndex };
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [selectedMedia]);

  return (
    <div className="mb-12  ">
      <div className="lg:flex ">
        <div className="lg:w-[44%] xl:pl-8 2xl:pl-36">
          <LatestEvents />
        </div>
        <div className="relative lg:w-[55%] xl:m-8 xs:px-8 sm:px-12 md:px-24 lg:px-6 h-[116vh] scrollbar-hide  overflow-y-auto">
          <div className="flex">
            <div className="absolute hidden lg:block mt-10 bg-[#081C3A] w-[3px] h-[150%] " />
            <div className="ml-8 ">
              <h1 className="text-[#081C3A] text-lg  pl-2 mt-10 mb-5 tracking-wider font-bold ">
                MEDIA COVERAGE
              </h1>
              <div className="mx-4 xxxs:mx-0  mr-16 space-y-20 xl:w-[520px] 2xl:w-[620px] ">
                {mediaImg?.map((item, id) => (
                  <div className="border" key={id}>
                    <div className="-ml-10 ">
                      {" "}
                      <motion.div
                        initial={{
                          opacity: 0,
                          translateY: +90,
                          translateX: -16,
                        }}
                        whileInView={{ opacity: 1, translateY: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        key="modal"
                      >
                        <CirclePointer />
                      </motion.div>
                    </div>
                    <div className="" key={item?.title}>
                      <motion.div
                        initial={{ opacity: 0, translateY: +90 }}
                        whileInView={{ opacity: 1, translateY: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        key="modal"
                      >
                        <div className="text-[#081C3A] text-2xl font-semibold ">
                          <h1 className="py-4 px-6 text-xl">{item?.title}</h1>
                          <div>
                            <div className="py-8 md:grid md:grid-cols-2 space-y-10 md:space-y-0">
                              {item?.media?.map((elm, idx) => (
                                <div
                                  className="shadow-lg border rounded-br-[100px] overflow-hidden rounded-tl-[100px] p-48px mx-8 drop-shadow-lg flex justify-center cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl"
                                  style={{
                                    borderRadius: "100px 0px 100px 0px",
                                    borderRight: "2px solid #32727A ",
                                    borderLeft: "2px solid #32727A ",
                                    padding: "42px",
                                  }}
                                  onClick={() => setSelectedMedia({
                                    media: item.media,
                                    index: idx,
                                    title: item.title
                                  })}
                                  key={idx}
                                >
                                  <img
                                    src={elm?.url}
                                    alt={item?.title || "Media Coverage"}
                                    className="w-[175.97px] h-[118.03px] object-cover"
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {selectedMedia && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-black/90 backdrop-blur-md"
            onClick={() => setSelectedMedia(null)}
          >
            {/* Close Button */}
            <button
              className="absolute top-6 right-6 z-[99999] p-3 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 shadow-lg cursor-pointer border border-white/20"
              onClick={() => setSelectedMedia(null)}
              aria-label="Close Lightbox"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Left Button (conditional) */}
            {selectedMedia.media.length > 1 && (
              <button
                className="absolute left-4 md:left-8 z-[99999] p-4 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 shadow-lg cursor-pointer border border-white/20 focus:outline-none"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMedia((prev) => {
                    if (!prev) return null;
                    const nextIndex = (prev.index - 1 + prev.media.length) % prev.media.length;
                    return { ...prev, index: nextIndex };
                  });
                }}
                aria-label="Previous Image"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
            )}

            {/* Main Content Area */}
            <div
              className="relative max-w-[90vw] md:max-w-4xl max-h-[70vh] flex flex-col items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Image Frame with motion for transition when index changes */}
              <motion.img
                key={selectedMedia.index} // triggers animation on index change
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25 }}
                src={selectedMedia.media[selectedMedia.index]?.url}
                alt={selectedMedia.title}
                className="max-w-full max-h-[65vh] object-contain rounded-lg shadow-2xl border border-white/10"
              />
            </div>

            {/* Caption & Counter */}
            <div
              className="mt-6 text-center max-w-[80vw] px-4"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="text-white text-lg md:text-xl font-medium tracking-wide drop-shadow-md">
                {selectedMedia.title}
              </h2>
              {selectedMedia.media.length > 1 && (
                <p className="text-white/60 text-sm mt-2 tracking-widest uppercase">
                  Image {selectedMedia.index + 1} of {selectedMedia.media.length}
                </p>
              )}
            </div>

            {/* Right Button (conditional) */}
            {selectedMedia.media.length > 1 && (
              <button
                className="absolute right-4 md:right-8 z-[99999] p-4 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 shadow-lg cursor-pointer border border-white/20 focus:outline-none"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMedia((prev) => {
                    if (!prev) return null;
                    const nextIndex = (prev.index + 1) % prev.media.length;
                    return { ...prev, index: nextIndex };
                  });
                }}
                aria-label="Next Image"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MediaCoverage;

export const CirclePointer = () => {
  return (
    <div className=" hidden lg:block  ">
      <div className=" absolute left-0  lg:flex border-2 rounded-full border-[#081C3A] w-12 h-12 bg-white items-center justify-center ">
        <div className="bg-[#32727A] rounded-full w-2 h-2" />
      </div>
    </div>
  );
};
